import Result from "@/core/common/Result";
import {
  IObterAgendamentosGateway,
  ObterAgendamentosResponse
} from "../ports/ObterAgendamentosGateway";
import { inject } from "inversify";
import { DITypes } from "@/core/@types/types";
import { type HttpClient } from "@/core/services/protocols/types";
import { IDefaultContabilResponse } from "@/features/contabil/services/types";
import { ContabilGatewayError } from "../../diagnostico/config/ContabilGatewayError";

export class ObterAgendamentosGatewayAdapter
  extends ContabilGatewayError
  implements IObterAgendamentosGateway
{
  @inject(DITypes.CONTABIL_HTTP_CLIENT)
  private readonly httpClient!: HttpClient;

  async getAgendamentos(): Promise<Result<ObterAgendamentosResponse>> {
    try {
      const response = await this.httpClient.get<
        IDefaultContabilResponse<ObterAgendamentosResponse>
      >({
        url: "v1/contabil/agendamentos/obter-agendamentos"
      });

      if (this.hasError(response)) {
        return Result.fail("Não foi possível obter os agendamentos");
      }

      return Result.ok(response.body?.result);
    } catch (_e) {
      return Result.fail(this.DEFAULT_ERROR);
    }
  }
}
